export default __webpack_public_path__ + "static/media/document.5f8696a5.svg";